











































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import BackgroundLines from "../BackgroundLines.vue";
import constants from '../../store/constants';
import Button from "../Button.vue";
import Swal from 'sweetalert2';
import axios from 'axios';
import ContactForm from "../../mixins/ContactForm";

@Component({
  components: {
    BackgroundLines,
    Button
  }
})
export default class WindowForm extends Mixins(ContactForm) {
  @Prop({ default: "" }) formName!: string;
  @Prop({ default: "" }) formCode!: string;
  formShowed = false;
  contentVisible = false;
  active = false;

  $refs!: {
    root: HTMLElement;
    wrapper1: HTMLElement;
    wrapper2: HTMLElement;
    whiteLine: HTMLElement;
    form: HTMLFormElement;
    content: HTMLElement;
  }

  @Watch("formShowed")
  stateChange(newValue: boolean, oldValue: boolean) {
    if (newValue) this.openWindow();
    else {
      this.closeWindow();
    }
  }

  openWindow() {
    this.active = true;
    this.contentVisible = true;
    setTimeout(() => {
      let width = Math.min(this.$browser.width, 540);
      (anime as any).set(this.$refs.whiteLine, { opacity: 1 });
      let tl = anime.timeline({ autoplay: true });
      tl.add({ targets: this.$refs.root, width: [0, width], duration: 680, easing: "easeOutQuad" });
      tl.add({ targets: this.$refs.whiteLine, opacity: [1, 0], duration: 700, easing: "easeOutQuad" }, 620);
      tl.add({ targets: this.$refs.root, height: [1, 450], duration: 500, easing: "easeOutQuad" }, 580);
      tl.add({ targets: this.$refs.wrapper1, opacity: [0, 1], duration: 500, easing: "easeOutQuad" }, 500);
    }, 50);
  }

  closeWindow() {
    this.active = false;
    let width = Math.min(this.$browser.width, 540);
    (anime as any).set(this.$refs.root, { height: this.$browser.height + "px" });
    let tl = anime.timeline({ autoplay: true });
    tl.add({ targets: this.$refs.wrapper1, opacity: [1, 0], duration: 500, easing: "easeOutQuad" }, 0);
    tl.add({ targets: this.$refs.whiteLine, opacity: [0, 1], duration: 700, easing: "easeOutQuad" }, 0);
    tl.add({ targets: this.$refs.root, height: [450, 1], duration: 500, easing: "easeOutQuad" }, 200);
    tl.add({ targets: this.$refs.root, width: [width, 0], duration: 680, easing: "easeOutQuad" }, 700);
    setTimeout(() => {
      if (!this.active) this.contentVisible = false;
    }, 2000);
  }

  mounted() {
    window.addEventListener("keydown", (e: KeyboardEvent) => {
      if (this.formShowed && e.keyCode == 27) {
        this.close();
      }
    });

    window.addEventListener(`openForm:${this.formCode}`, () => {
      this.formShowed = true;
    });
  }

  close() {
    this.formShowed = false;
  }

  formSended() {
    this.close();
    let inputs = this.$refs.form.querySelectorAll<HTMLInputElement>("input[name='telephone'], input[name='name']");
    inputs.forEach(input => {
      input.value = "";
    });
  }
}
